import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";

import { ModalTypes } from "components/modals/interfaces";
import features from "features";

import FormField from "components/inputs/FormField/FormField";
import PrimaryButton from "../PrimaryButton/PrimaryButton";

import PlusIcon from "assets/icons/plus.svg";

const NewProjectButton = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleFormSubmit = useCallback(
    (values) => {
      dispatch(
        features.main.actions.createProjectRequest({
          fields: { ...values },
          onSuccess: (res) => {
            navigate(`/map/${res.id}`);
          }
        })
      );
    },
    [dispatch, navigate]
  );

  const onCreateProject = useCallback(() => {
    dispatch(
      features.modal.actions.showModal({
        modalType: ModalTypes.FORM,
        modalProps: {
          title: "Create project",
          description: "Please enter project name.",
          initialValues: { name: "" },
          onSubmit: handleFormSubmit,
          validationSchema: Yup.object().shape({
            name: Yup.string().required("Project name is required")
          }),
          acceptButtonLabel: "Send",
          formContent: (
            <>
              <FormField name="name" placeholder="Project name" />
            </>
          )
        }
      })
    );
  }, [dispatch, handleFormSubmit]);

  return (
    <PrimaryButton icon={PlusIcon} onClick={onCreateProject}>
      New project
    </PrimaryButton>
  );
};

export default NewProjectButton;
